import { render, staticRenderFns } from "./OpportunityPage.vue?vue&type=template&id=6f39590a&scoped=true&"
import script from "./OpportunityPage.vue?vue&type=script&lang=js&"
export * from "./OpportunityPage.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityPage.vue?vue&type=style&index=0&id=6f39590a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f39590a",
  null
  
)

export default component.exports